export const FIELD_LABEL_MAPPING = {
    // Form field keys
    'firstname': 'Ad',
    'lastname': 'Soyad',
    'address': 'Adres',
    'address_country': 'Adres Ülkesi',
    'county': 'İlçe',
    'postcode': 'Posta Kodu',
    'id_number': 'Kimlik Numarası',
    'id_type': 'Kimlik Türü',
    'city_state': 'Şehir/İl',
    'birth_day': 'Doğum Tarihi',
    'Nationality': 'Uyruk',
    'Birthplace': 'Doğum Yeri',
    'Country': 'Ülke',
    'email': 'E-posta',
    'phone': 'Telefon',
    'birthdate': 'Doğum Tarihi',
    'address_line_1': 'Adres Satırı 1',
    'address_line_2': 'Adres Satırı 2',
    'town_or_city': 'İlçe/Şehir',
    'state_province_region': 'İl/Eyalet/Bölge',
    'file_upload': 'Dosya Yükleme',

    // KYB (Know Your Business) field keys
    'company_name': 'Şirket Adı',
    'company_email': 'Şirket E-posta',
    'registration_number': 'Kayıt Numarası',
    'date_of_incorporation': 'Kuruluş Tarihi',
    'registered_address': 'Kayıtlı Adres',
    'business_type': 'İş Türü',
    'industry_type': 'Sektör Türü',
    'url': 'Web Sitesi',
    'registered_country': 'Kayıtlı Ülke',
    'registered_city_state': 'Kayıtlı Şehir/İl',
    'registered_postcode': 'Kayıtlı Posta Kodu',
    'registered_county': 'Kayıtlı İlçe',
    'revenue': 'Gelir',
    'revenue_currency': 'Gelir Para Birimi',
    'account_number': 'Hesap Numarası',
    'policy_number': 'Poliçe Numarası',
    'coverage_amount': 'Teminat Tutarı',
    'coverage_amount_currency': 'Teminat Para Birimi',
    'insurance_expiry_date': 'Sigorta Bitiş Tarihi',
    'ubo_description': 'UBO Açıklaması',
    'ubo_type': 'UBO Türü',
    'authorized_signatory': 'Yetkili İmza',

    // Raw data labels (English -> Turkish)
    'File Upload': 'Dosya Yükleme',
    'First Name': 'Ad',
    'Last Name': 'Soyad',
    'Email': 'E-posta',
    'Phone': 'Telefon',
    'Address': 'Adres',
    'Address Country': 'Adres Ülkesi',
    'County': 'İlçe',
    'Postcode': 'Posta Kodu',
    'ID Number': 'Kimlik Numarası',
    'ID Type': 'Kimlik Türü',
    'City State': 'Şehir/İl',
    'Birth Day': 'Doğum Tarihi',
    'Birthdate': 'Doğum Tarihi',
    'Address Line 1': 'Adres Satırı 1',
    'Address Line 2': 'Adres Satırı 2',
    'Town or City': 'İlçe/Şehir',
    'State / Province / Region': 'İl/Eyalet/Bölge',

    // KYB raw data labels (English -> Turkish)
    'Financial Statements': 'Mali Tablolar',
    'Application Form': 'Başvuru Formu',
    'Certificate Of Incorporation Or Registration': 'Kuruluş veya Kayıt Sertifikası',
    'Operation License': 'İşletme Lisansı',
    'Domain Proof': 'Domain Kanıtı',
    'Crypto Currency Questionnaire': 'Kripto Para Anketi',
    'Certificate Of Good Standing': 'İyi Hal Sertifikası',
    'AML/CFT Compliance Policy And Procedures (For Regulated Entities)': 'AML/CFT Uyum Politikası ve Prosedürleri (Düzenlenmiş Kuruluşlar İçin)',
    'Organisation Chart': 'Organizasyon Şeması',
    'Other': 'Diğer',
    'Trading Bank Statements': 'Ticari Banka Hesap Özetleri',
    'Shareholders Register': 'Ortaklar Sicili',
    'Recent Certificate Of Incumbency': 'Güncel Görev Sertifikası',
    'Memorandum Of Association Or Articles Of Incorporation': 'Ortaklık Sözleşmesi veya Kuruluş Senedi',
    'Company Proof of Address': 'Şirket Adres Kanıtı',
    'Directors Register Certificate': 'Yönetim Kurulu Sicil Sertifikası',
    'Wolfsberg S Questionnaire': 'Wolfsberg S Anketi',
    'Proof of Address': 'Adres Kanıtı',
    'Insurance Certificates': 'Sigorta Sertifikaları',
    'Contractual Documents': 'Sözleşme Belgeleri',
    'Licenses and Permits': 'Lisanslar ve İzinler',
    'Company Registration': 'Şirket Kaydı',
    'Business License': 'İş Lisansı',
    'Tax Certificate': 'Vergi Sertifikası',
    'Bank Statement': 'Banka Hesap Özeti',
    'Insurance Policy': 'Sigorta Poliçesi',
    'UBO Document': 'UBO Belgesi',
    'Authorized Signatory': 'Yetkili İmza',
    'Director': 'Yönetici',
    'Owner': 'Sahip',
    'Shareholder': 'Hissedar',
    'Individual': 'Bireysel',
    'Corporate': 'Kurumsal'
};

export const FIELD_LABEL_JA_MAPPING = {
    // ===== KYC / 개인 정보 =====
    firstname: '名',
    lastname: '姓',
    email: 'メールアドレス',
    phone: '電話番号',

    birth_day: '生年月日',     // eski key
    birthdate: '生年月日',     // yeni key
    Birthplace: '出生地',
    Nationality: '国籍',

    id_number: '身分証番号',
    id_type: '身分証の種類',

    // ===== 住所 =====
    address: '住所',
    address_country: '居住国',
    Country: '国',

    address_line_1: '住所（番地・建物名など）',
    address_line_2: '住所（部屋番号など）',

    town_or_city: '市区町村',
    city_state: '都道府県・市区町村',
    state_province_region: '都道府県',
    county: '郡/州（該当する場合）',
    postcode: '郵便番号',

    file_upload: 'ファイルアップロード',

    // ===== KYB / 法人情報 =====
    company_name: '会社名',
    company_email: '会社メールアドレス',
    registration_number: '法人登録番号',
    date_of_incorporation: '設立日',
    registered_address: '登記住所',
    business_type: '事業形態',
    industry_type: '業種',
    url: 'ウェブサイトURL',
    registered_country: '登記国',
    registered_city_state: '登記住所（都道府県・市区町村）',
    registered_postcode: '登記住所（郵便番号）',
    registered_county: '登記住所（郡/州）',

    revenue: '年間売上高',
    revenue_currency: '通貨（売上）',

    account_number: '口座番号',
    policy_number: '証券番号',

    coverage_amount: '補償額',
    coverage_amount_currency: '通貨（補償額）',
    insurance_expiry_date: '保険満了日',

    ubo_description: '実質的支配者（UBO）の説明',
    ubo_type: '実質的支配者（UBO）の区分',
    authorized_signatory: '署名権者',

    // ===== Raw data labels (English -> Japanese) =====
    'File Upload': 'ファイルアップロード',
    'First Name': '名',
    'Last Name': '姓',
    'Email': 'メールアドレス',
    'Phone': '電話番号',

    'Address': '住所',
    'Address Country': '居住国',
    'County': '郡/州（該当する場合）',
    'Postcode': '郵便番号',

    'ID Number': '身分証番号',
    'ID Type': '身分証の種類',

    'City State': '都道府県・市区町村',
    'Birth Day': '生年月日',
    'Birthdate': '生年月日',

    'Address Line 1': '住所（番地・建物名など）',
    'Address Line 2': '住所（部屋番号など）',
    'Town or City': '市区町村',
    'State / Province / Region': '都道府県',

    // ===== KYB raw data labels (English -> Japanese) =====
    'Financial Statements': '財務諸表',
    'Application Form': '申請書',
    'Certificate Of Incorporation Or Registration': '設立/登録証明書',
    'Operation License': '営業許可証',
    'Domain Proof': 'ドメイン所有証明',
    'Crypto Currency Questionnaire': '暗号資産に関する質問票',
    'Certificate Of Good Standing': '存続証明書（Good Standing）',
    'AML/CFT Compliance Policy And Procedures (For Regulated Entities)':
        'AML/CFT コンプライアンスポリシーおよび手続き（規制対象事業者）',
    'Organisation Chart': '組織図',
    'Other': 'その他',
    'Trading Bank Statements': '取引銀行残高証明/明細',
    'Shareholders Register': '株主名簿',
    'Recent Certificate Of Incumbency': '現任証明書（Incumbency）',
    'Memorandum Of Association Or Articles Of Incorporation': '定款（または同等書類）',
    'Company Proof of Address': '会社住所証明',
    'Directors Register Certificate': '取締役名簿（証明書）',
    'Wolfsberg S Questionnaire': 'ウルフスバーグ質問票',
    'Proof of Address': '住所証明',
    'Insurance Certificates': '保険証明書',
    'Contractual Documents': '契約書類',
    'Licenses and Permits': '許認可',
    'Company Registration': '会社登録',
    'Business License': '営業許可',
    'Tax Certificate': '納税証明書',
    'Bank Statement': '銀行取引明細',
    'Insurance Policy': '保険証券',
    'UBO Document': '実質的支配者（UBO）関連書類',

    // Roles / types
    'Authorized Signatory': '署名権者',
    Director: '取締役',
    Owner: '所有者',
    Shareholder: '株主',
    Individual: '個人',
    Corporate: '法人',
};

/**
 * Get localized field label
 * @param {string} key - Field key
 * @param {string} currentLanguage - Current language code
 * @returns {string} - Localized label
 */
export const getFieldLabel = (key, currentLanguage = 'en') => {
    // If Turkish is selected, use Turkish mapping
    if (currentLanguage === 'tr') {
        return FIELD_LABEL_MAPPING[key] || key.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase());
    }
    if (currentLanguage === 'ja') {
        const jaMapping = FIELD_LABEL_JA_MAPPING || {};
        return jaMapping[key] || key.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase());
    }
    // For other languages, use English format
    return key.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase());
};
